
<div *ngIf="doShowSurvey; then block1 else block2"></div>

<ng-template #block1>
  <!-- Content for block1 -->
<!--


<div style="display: flex;border-bottom: solid 3px rgba(60, 72, 94, 0.2);justify-content: space-between;">
  <div style="margin: 10px;font-size: 30px;">
    <h2 class="head" style="padding-bottom: 0px; margin-bottom: 0px;border-bottom: 0px">&nbsp;</h2></div>
  <div style="font-size: 30px;position: relative;">
    <button class="action primary read-more" style="position: absolute;right: 0" [routerLink]="'/about'">
      Find out more about Startup Muster...
    </button>
  </div>
</div>
<br/>
<br/>
--->


<div>
  <section>
    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      If you are <strong>running a startup in Australia</strong>, or <strong>supporting startups in Australia</strong> (educators, investors, accelerators, incubators, coworking spaces, service providers, government, precincts and any other organisations supporting startups),
      <strong>please contribute your data</strong> below to the largest survey of Australia's startup ecosystem.
    </span>
    </p>
    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
      <!--
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      {{ daysRemaining }} days left to take part before survey closes on September 15th.
    </span>
    -->
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>Why? Because:</strong>
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>1.&nbsp;You're joining an unprecedented national effort to show the great things in Australia's startup ecosystem </strong>, the areas that need improvement, and your opinions on critical policy issues. For the first time, we now have Survey Coordinators on the ground in every single state and territory, and the national report this enables will be freely published in late 2026. Your responses will also be shared with relevant parts of Government and for research (if you give permission for each).
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>2.&nbsp;We've combined questions this year from many different startup supporters and government departments</strong>, preventing a suite of new surveys. These are questions from the ecosystem, for the ecosystem, and we've also worked to trim 25 questions from our last survey that didn't yield actionable data.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>3.&nbsp;You'll contribute to a twelve year legacy of Australian ecosystem data.</strong> Many of these questions date back to our first survey in 2013, with a similar collection approach, providing a unique picture of how this sector has evolved.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>4.&nbsp;You'll see comparison charts</strong> that show how your answers compare to other survey participants so far this year.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>5.&nbsp;You'll receive special offers and discounts</strong> on completion from our partners.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      This survey will take a while (grab a coffee), but you can stop any time and come back to resume later. We're confident you can complete the survey in much less time than a typical policy consultation session.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>Please join us in thanking our 2026 partners</strong>: Optus, ARENA, Research Link Australia (ARDC), City of Sydney, ACS Labs, Rippling, Stone & Chalk, Main Sequence, Queensland University of Technology, University of Newcastle, Pledge 1%, National AI Centre, CSIRO, Ashurst, Baxter IP and Gild Group.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
    <strong>Please also join us in welcoming our national Survey Coordinators: </strong>
          <a href="https://www.linkedin.com/in/daniellemeyerseymour/" target="_blank" rel="noopener noreferrer">Danielle Seymour</a> from _SOUTHSTART (SA),
          <a href="https://www.linkedin.com/in/kate-montgomery-aus/" target="_blank" rel="noopener noreferrer">Kate Montgomery</a> from Tropical Innovation Festival (QLD),
          <a href="https://www.linkedin.com/in/nate-sturcke/" target="_blank" rel="noopener noreferrer">Nate Sturcke</a> from Spacecubed (WA),
          <a href="https://www.linkedin.com/in/emma-nesbitt/" target="_blank" rel="noopener noreferrer">Emma Nesbitt</a> from ACTIO Group (NT),
          <a href="https://www.linkedin.com/in/petradamek/" target="_blank" rel="noopener noreferrer">Petr Adámek</a> from CBRIN (ACT),
          <a href="https://www.linkedin.com/in/talithatazdevadass/" target="_blank" rel="noopener noreferrer">Taz Devadass</a> from Futures Isle (TAS),
          <a href="https://www.linkedin.com/in/claire-gifford/" target="_blank" rel="noopener noreferrer">Claire Gifford</a> from LaunchVic (VIC),
          <a href="https://www.linkedin.com/in/maxine-sherrin-b1b66/" target="_blank" rel="noopener noreferrer">Maxine Sherrin</a> from Spark Festival (NSW) 👏
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      <strong>Want to help promote?</strong> Find promotional assets
      <a style="text-decoration:none;color:#406ab5;" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/drive/folders/16uyZKrGw-9ectaGJYzMtQe1HVuqbAmBR">here</a>, and please contact us if you need assets that aren’t in the folder. Promotion to under-represented startup communities is especially appreciated.
    </span>
    </p>

    <p style="line-height:1.68;margin-bottom:15pt;margin-top:0pt;" dir="ltr">
    <span style="background-color:transparent;color:#44546a;font-family:Roboto,sans-serif;font-size:13.5pt;">
      Thank you for supporting Startup Muster’s mission to measure and publish the progress, challenges, and opportunities within the Australian startup ecosystem, in order to demonstrate and accelerate progress.
    </span>
    </p>
  </section>
  <p>
    &nbsp;
  </p>
  <br/>
</div>
<div *ngIf="showNewSurvey" class="new-survey">
  <button class="action" (click)="newSurvey()">
    Save and start new survey submission
  </button>
</div>

<ng-container *ngIf="showPrevious">
  <p>
    <strong>Did you complete (or start) a Startup Muster survey previously? This year or in a past year.</strong
    >
  </p>

  <p class="start-actions">
    <button
      class="previous"
      [ngClass]="{ selected: state.page.flowState === 'yes-previous' }"
      (click)="onClickPreviousYes()"
    >
      Yes
    </button>

    <button
      class="previous"
      [ngClass]="{ selected: state.page.flowState === 'no-previous' }"
      (click)="onClickPreviousNo()"
    >
      No
    </button>
  </p>

  <ng-container *ngIf="state.page.flowState === 'yes-previous'">
    <p>
      <strong
        >You can complete the survey faster and easier by simply updating your
        previous responses.</strong
      >
    </p>

    <app-login-inline></app-login-inline>

    <!--
      <button class="action previous"
              [routerLink]="'/login/update'">

      </button>
    -->
  </ng-container>
</ng-container>

<!--
  <div class="progress">
    <div class="progress-label">Progress:</div>

    <app-progress [percentage]="state.progressPercentage"></app-progress>
  </div>
-->

<div
  class="section"
  [appShow]="showSurvey"
  [ngClass]="{ alt: isAlt(section) }"
  *ngFor="let section of state.sections; trackBy: trackById"
>
  <h2>{{ section.title }}</h2>

  <div
    class="question component"
    *ngFor="let qr of section.questionResponses; trackBy: trackByQuestionId"
  >
    <app-question-status [status]="qr.status"></app-question-status>

    <h3 [appRewriteLinks]="qr.question.text"></h3>

    <app-question [state]="qr"> </app-question>

    <app-compare-button
      *ngIf="qr.question.showResultsAfterLockout"
      [appShow]="!hideCompare(qr)"
      [state]="qr"
      (compare)="onCompareResults(qr)"
    ></app-compare-button>

    <app-question-results
      *ngIf="showResults(qr)"
      [results]="qr.results"
    ></app-question-results>

    <div class="why" *ngIf="qr.question.whyText" [appShow]="showWhy(qr)" [innerHTML]="qr.question.whyText"></div>

    <div
      *ngIf="qr.question.key === 'QUserTypeReturningEmail'"
      [appShow]="state.isReturning"
    >
      <p class="error" [appShow]="state.loginLinkRequestFailed">
        No survey response found. Please note this only works for surveys completed in 2025 or later. Please check the address entered, or start a new survey below.
      </p>

      <button (click)="requestLogin()">Request Login Link</button>
    </div>

    <div *ngIf="qr.question.key === 'QFinal'" class="final">
      <div *ngIf="userType.isFuture || userType.isStartup">
        <!--
          <p>Thank you for taking part in the Startup Muster 2017 Survey!</p>
        -->
        <p>
          Your contribution means that Australia will have representative and
          useful statistics about the Australian startup community.
        </p>
      </div>
      <!--
                <p>Thank you for taking part in the Startup Muster 2017 Survey.</p>

      <div class="helper" *ngIf="userType.isHelper">

        <p>
          We also now provide an option for your support to be shown to startups
          using targeting criteria.
        </p>
        <button class="action" (click)="completeSurvey()">
          Enter my targeting criteria so I can be seen by startups
        </button>
      </div>
      -->
      <!--
      <div class="startup" *ngIf="userType.isStartup && !userType.isHelper">
        <button class="action" (click)="completeSurvey()">
          Connect with helpers
        </button>
      </div>
      -->
      <div>
        <p>To fill out another survey, please select the following option:</p>

        <button class="action" (click)="newSurvey()">
          Fill out another survey
        </button>
      </div>
    </div>
  </div>
</div>
</ng-template>

<ng-template #block2>
  <app-survey-offline></app-survey-offline>

</ng-template>
